import { useState, useCallback } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function fetchJson(path, options = {}) {
  const r = await fetch(`${API}${path}`, { credentials: 'include', ...options });
  if (!r.ok) {
    const err = await r.text();
    throw new Error(err || `HTTP ${r.status}`);
  }
  return r.json();
}

export function useProjects() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);

  const list = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchJson('/projects');
      setProjects(data);
      return data;
    } finally {
      setLoading(false);
    }
  }, []);

  const create = useCallback(async (payload) => {
    const proj = await fetchJson('/projects', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    setProjects((prev) => [proj, ...prev]);
    return proj;
  }, []);

  const update = useCallback(async (id, payload) => {
    const proj = await fetchJson(`/projects/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    setProjects((prev) => prev.map((p) => (p.project_id === id ? proj : p)));
    return proj;
  }, []);

  const get = useCallback(async (id) => {
    return fetchJson(`/projects/${id}`);
  }, []);

  const remove = useCallback(async (id) => {
    await fetchJson(`/projects/${id}`, { method: 'DELETE' });
    setProjects((prev) => prev.filter((p) => p.project_id !== id));
  }, []);

  return { projects, loading, list, create, update, get, remove };
}
